import SessionBase from './base/SessionBase';

/**
 * @class Session
 * @extends SessionBase
 */
class Session extends SessionBase {

}

export default Session;
